import { View, Text, ScrollView, Image, ActivityIndicator } from "react-native";
import React, { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CommonButton } from "../../common/CommonButton";
import { AppImages } from "../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppScreens } from "../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import SearchComponent from "../../Components/choose-game-components/SearchComponent";
import GameComponent from "../../Components/choose-game-components/GameComponent";
import { getLoginData, storeLoginData } from "../../utility/AppStoreData";
import { base_url, endpoints } from "../../Api/configs";
import { toast } from "react-toastify";
import { ShowLoader } from "../../common/ShowLoader";
import { getUserProfile, login } from "../../services/authAPI";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { updateUserGames } from "../../services/authAPI";
import ChooseGameLikeSkeleton from "../../Components/skeleton-components/ChooseGameLikeSkeleton";
import ChooseAvatarSkeleton from "../../Components/skeleton-components/ChooseAvatarSkeleton";
import AvatarComponent from "../../Components/choose-avatar-components/AvatarComponent";
import Separator from "../../Components/Separator";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AvatarLookComponent } from "../../Components/choose-avatar-components/AvatarLookComponent";
import { Dimensions } from "react-native";
import { fetchAvatar, updateAvatarToProfile } from "../../services/avatarAPI";
import { ScreenBGGradientView } from "../../common/CommonView";
const ChooseAvatarScreen = ({ route }) => {
  const routeData = route.params;
  const username = routeData?.username;
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [filteredAvatars, setFilteredAvatars] = useState([]);
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);
  const [showUpdateGamesLoader, setShowUpdateGamesLoader] = useState(false);
  const [isContinueLoading, setIsContinueLoading] = useState(false);
  const [selectedAvatarDetails, setSelectedAvatarDetails] = useState(null);
  const [selectedAvatarPart, setSelectedAvatarPart] = useState("full");
  const [selectedAvatarUrl, setSelectedAvatarUrl] = useState(
    "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
  );
  const [selectedAvatar, setSelectedAvatar] = useState("tiger");

  const screenHeight = Dimensions.get("window").height;
  const handleAvatarPartSelection = (url) => {
    setSelectedAvatarUrl(url);
  };

  const normalizedAvatars = filteredAvatars.reduce((acc, avatars) => {
    Object.values(avatars).forEach((avatar) => acc.push(avatar));
    return acc;
  }, []);
  useEffect(() => {
    if (filteredAvatars.length > 0) {
      // Find the object that contains the "tiger" avatar
      const tigerAvatarObject = filteredAvatars.find((avatarObj) =>
        Object.keys(avatarObj).includes("tiger")
      );

      if (tigerAvatarObject) {
        setSelectedAvatarDetails(tigerAvatarObject["tiger"]);
        setSelectedAvatarUrl(tigerAvatarObject["tiger"].full);
      }
    }
  }, [filteredAvatars]);

  const getAvatars = async () => {
    setShowLoader(true);

    try {
      const response = await fetchAvatar();

      if (response.statusCode === 200) {
        setFilteredAvatars(response.avatars);
      } else {
        toast.error(response.error);
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getAvatars();
  }, []);

  const updateAvatar = async () => {
    setIsContinueLoading(true);
    try {
      const params = {
        username,
        profilePic: selectedAvatarUrl,
        avatarName: selectedAvatar,
        avatarPart: selectedAvatarPart,
      };
      const response = await updateAvatarToProfile(params);
      if (response.statusCode === 200) {
        toast.success(response.body.message);
      } else {
        toast.error(response.body.error);
      }
      setIsContinueLoading(false);
    } catch (error) {
      setIsContinueLoading(false);
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  return (
    <View style={styles.container}>
      <ScreenBGGradientView />
      {showLoader ? (
        <ChooseAvatarSkeleton />
      ) : (
        <View
          style={{
            paddingHorizontal:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? s(8)
                : s(8),
            paddingTop:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? s(8)
                : s(8),
            flex: 1,
          }}
        >
          {/* Header with KO Logo */}
          <View style={styles.headerContainer}>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_24
                  : AppFontStyle.BOLD_ANYBODY_40,
                {
                  color: AppColors.white,
                },
              ]}
            >
              {"Select Avatar"}
            </Text>
            <Image
              source={AppImages.KO_LOGO_Main}
              style={styles.koLogo}
              resizeMode="contain"
            />
          </View>
          <View
            style={{
              display: "flex",
              marginBottom:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 8
                  : 0,
              marginTop: 8,
              flexDirection:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "column-reverse"
                  : "row",
            }}
          >
            <LinearGradient
              colors={["#111827", "#000000"]}
              start={[0, 0]}
              end={[0, 1]}
              style={{
                borderRadius: 12,
                padding: 8,
                flex:
                  deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                    ? 1
                    : 0.72,
              }}
            >
              <ScrollView
                contentContainerStyle={[
                  styles.gridContainer,
                  {
                    height:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? screenHeight - 350
                        : 525,
                  },
                ]}
                style={styles.scrollView}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
              >
                {normalizedAvatars.map((avatar, index) => (
                  <AvatarComponent
                    key={index}
                    avatar={avatar}
                    isSelected={selectedAvatarDetails?.full === avatar.full}
                    onSelectionChange={() => {
                      const avatarName = Object.keys(filteredAvatars[index])[0];
                      setSelectedAvatar(avatarName);
                      setSelectedAvatarDetails(avatar); // Store the selected avatar's details
                      setSelectedAvatarUrl(avatar.full); // Store the selected avatar's details
                    }}
                    styles={styles}
                  />
                ))}
              </ScrollView>
            </LinearGradient>
            <Separator
              height={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "1px"
                  : "100%"
              }
              color={AppColors.white}
              width={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "100%"
                  : "1px"
              }
              marginHorizontal={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : 8
              }
              marginBottom={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 10
                  : null
              }
              marginTop={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : null
              }
            />
            {(deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS) ? (
              <AvatarLookComponent
                selectedAvatarDetails={selectedAvatarDetails}
                selectedAvatarPart={selectedAvatarPart}
                handleAvatarPartSelection={handleAvatarPartSelection}
                setSelectedAvatarPart={setSelectedAvatarPart}
              />
            ) : (
              <View
                style={{
                  flex: 0.28,
                }}
              >
                <AvatarLookComponent
                  selectedAvatarDetails={selectedAvatarDetails}
                  selectedAvatarPart={selectedAvatarPart}
                  handleAvatarPartSelection={handleAvatarPartSelection}
                  setSelectedAvatarPart={setSelectedAvatarPart}
                />
              </View>
            )}
          </View>
          <LinearGradient
            colors={["#111827", "#000000"]}
            start={[0, 0]}
            end={[0, 1]}
            style={{
              marginTop: s(8),
              marginBottom:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : s(8),
              flexDirection: "row",
              gap: s(10),
              justifyContent: "space-between",
              alignItems: "center",
              position: "absolute",
              bottom: 0,
              left:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 5
                  : 18,
              right:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 5
                  : 18,
              width:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "95%"
                  : null,
              padding: 18,
              borderRadius: 12,
            }}
          >
            <CommonButton
              title="Skip"
              onTap={async () => {
                await updateAvatar();
                navigateToScreen(navigation, AppScreens.ChooseGameLikeScreen, {
                    username: routeData.username,
                  });
              }}
              buttonStyle={{
                paddingVertical: 10,
                paddingHorizontal: 24,
                backgroundColor: "transparent",
                borderRadius: 6,
                borderWidth: 1,
                borderColor: AppColors.white,
                height: 40,
              }}
            />
            <TouchableOpacity
              onPress={async () => {
                if (!isContinueLoading) {
                  await updateAvatar();
                  navigateToScreen(navigation, AppScreens.ChooseGameLikeScreen, {
                    username: routeData.username,
                  });
                }
              }}
              disabled={isContinueLoading}
              style={{
                paddingVertical: 10,
                paddingHorizontal: 24,
                backgroundColor: "#DC2626",
                borderRadius: 6,
                width: 158,
                height: 40,
                justifyContent: "center",
                alignItems: "center",
                opacity: isContinueLoading ? 0.7 : 1,
              }}
            >
              {isContinueLoading ? (
                <ActivityIndicator size="small" color={AppColors.white} />
              ) : (
                <Text style={[AppFontStyle.BOLD_ANYBODY_14, { color: AppColors.white }]}>
                  Continue
                </Text>
              )}
            </TouchableOpacity>
          </LinearGradient>
        </View>
      )}
    </View>
  );
};

export default ChooseAvatarScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      flexDirection: "row",
    },
    headerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 8,
    },
    koLogo: {
      width: 183,
      height: 99.408,
      flexShrink: 0,
    },
    gridContainer: {
      justifyContent: "flex-start",
      flexDirection: "row",
      flexWrap: "wrap",
      paddingHorizontal: 8,
      paddingVertical: 8,
      gap: 12,
    },
    scrollView: {
      height: "100%",
    },
    loaderContainer: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
      zIndex: 10, // Ensure the loader is on top
    },
    shodowBottom: {
      height: "40%",
      width: "30%",
      position: "absolute",
      resizeMode: "stretch",
      bottom: 0,
    },
    shodowTopRight: {
      width: 820,
      height: 546,
      position: "absolute",
      resizeMode: "stretch",
      top: 0,
      right: 0,
      flexShrink: 0,
      // transform: [{ rotate: "6.171deg" }],
    },
    serachBtn: {
      width: 24,
      height: 24,
    },
    item: {
      flex: 1,
      //   height: 168,
      borderRadius: s(10),
      borderWidth: s(2),
      borderColor: AppColors.white,
      elevation: s(2),
      gap: s(14),
    },
    searchTextStyle: {
      width: 459,
      height: 35,
      alignItems: "center",
      borderWidth: 0,
    },
    columnWrapperStyle: {
      // height: 96
      overflow: "scroll",
      gap: s(3),
      display: "flex",
    },
    suggestionBox: {
      backgroundColor: AppColors.appBlueColor_3A5175,
      borderRadius: 10,
      position: "absolute",
      top: 45,
      zIndex: 1000,
      width: 459,
      maxHeight: 200,
    },
    suggestionItem: {
      padding: 10,
      borderBottomWidth: 1,
      borderBottomColor: AppColors.white + "33",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        overflow: "scroll",
        gap: s(10),
      },
    },
    [DEVICE_SIZES.MD]: {
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: 459,
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        // gap: s(150),
        // // width: "100%",
        overflow: "scroll",
        gap: s(8),
      },
    },
    [DEVICE_SIZES.SM]: {
      gridContainer: {
        justifyContent: "flex-start",
        gap: 12,
        paddingHorizontal: 8,
        paddingVertical: 8,
      },
      koLogo: {
        width: 120,
        height: 65,
      },
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: "90%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        // gap: s(150),
        // // width: "100%",
        overflow: "scroll",
        gap: s(6),
      },
      suggestionBox: {
        width: "90%",
      },
    },
    [DEVICE_SIZES.XS]: {
      gridContainer: {
        justifyContent: "flex-start",
        gap: 12,
        paddingHorizontal: 8,
        paddingVertical: 8,
      },
      koLogo: {
        width: 100,
        height: 54,
      },
      shodowBottom: {
        height: "25%",
        width: "50%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: "90%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      columnWrapperStyle: {
        gap: s(4),
        // width: "100%",
        overflow: "scroll",
      },
      shodowTopRight: {
        width: 545,
        height: 283,
      },
      suggestionBox: {
        width: "90%",
      },
    },
  }
);
